'use client';
import React from 'react';
import {
  Compass,
  Cpu,
  LayoutDashboard,
  SlidersHorizontal,
  Sparkles,
  Rocket,
  ArrowRight,
} from 'lucide-react';

export const TTOSWayProcess: React.FC = () => {
  const steps = [
    {
      title: 'Choose Industry',
      desc: 'Pick your business industry or type',
      icon: Compass,
      color: 'text-amber-600 bg-amber-50',
    },
    {
      title: 'TT OS Understands',
      desc: 'We analyze your business and market',
      icon: Cpu,
      color: 'text-emerald-600 bg-emerald-50',
    },
    {
      title: 'Get Workspace',
      desc: 'Your personalized AI workspace is ready',
      icon: LayoutDashboard,
      color: 'text-blue-600 bg-blue-50',
    },
    {
      title: 'Choose What You Need',
      desc: 'Select tools, templates or services',
      icon: SlidersHorizontal,
      color: 'text-purple-600 bg-purple-50',
    },
    {
      title: 'AI Does The Work',
      desc: 'Our AI creates, writes, designs, optimizes',
      icon: Sparkles,
      color: 'text-pink-600 bg-pink-50',
    },
    {
      title: 'Publish & Grow',
      desc: 'Go live, get more customers, grow fast',
      icon: Rocket,
      color: 'text-teal-600 bg-teal-50',
    },
  ];

  return (
    <section id="how-it-works" className="py-16 bg-[#FAFAFA] border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading (Matching Screenshot exactly) */}
        <div className="text-center max-w-2xl mx-auto space-y-1 mb-12">
          <p className="text-xs font-bold text-slate-500 tracking-wider">
            The TT OS Way
          </p>
          <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">
            Don&apos;t Prompt. Just Choose.
          </h2>
        </div>

        {/* 6 Steps Grid with Flow Connectors */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4 relative">
          {steps.map((step, idx) => (
            <div key={idx} className="relative flex items-center">
              
              {/* Card Container */}
              <div className="w-full h-full bg-white rounded-2xl p-5 border border-slate-200/80 shadow-xs hover:border-indigo-300 hover:shadow-md transition-all duration-200 flex flex-col items-center text-center">
                
                {/* Icon Circle */}
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-3.5 shadow-xs ${step.color}`}>
                  <step.icon className="w-6 h-6" />
                </div>

                {/* Step Title */}
                <h3 className="text-xs font-bold text-slate-900 leading-snug">
                  {step.title}
                </h3>

                {/* Step Description */}
                <p className="text-[11px] text-slate-500 mt-1.5 leading-relaxed">
                  {step.desc}
                </p>

              </div>

              {/* Connecting Arrow for Desktop */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:flex absolute -right-2.5 top-1/2 -translate-y-1/2 z-10 w-5 h-5 rounded-full bg-white border border-slate-200 items-center justify-center text-slate-400 shadow-xs">
                  <ArrowRight className="w-3 h-3" />
                </div>
              )}

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TTOSWayProcess;
